var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer flex-shrink-0 text-center"},[_c('img',{attrs:{"src":require('@/assets/images/nlc_logo.png'),"alt":"","width":"86"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }